import cx from 'classnames';
import {ReactNode} from 'react';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

import './Step.sass';

type StepProps = {
  children: ReactNode;
  header: ReactNode;
  footer?: ReactNode;
  title?: string;
  description?: string;
  headerClassName?: string;
  contentClassName?: string;
  footerClassName?: string;
};

export const Step = ({
  header,
  children,
  title,
  description,
  footer,
  headerClassName,
  contentClassName,
  footerClassName,
}: StepProps) => {
  const isLargishAndUp = useIsLargishAndUp();

  return (
    <div className="rsvp-step">
      <div className={cx('rsvp-step__header', headerClassName)}>{header}</div>

      <div className={cx('rsvp-step__content', contentClassName)}>
        {title && (
          <Typography variant="paragraph1" semibold className="rsvp-step-title">
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant={isLargishAndUp ? 'paragraph3' : 'paragraph2'}>
            {description}
          </Typography>
        )}
        {children}
      </div>

      {footer && <div className={cx('rsvp-step__footer', footerClassName)}>{footer}</div>}
    </div>
  );
};
